import { render, staticRenderFns } from "./BloggerLayout.vue?vue&type=template&id=353b48cb&scoped=true"
import script from "./BloggerLayout.vue?vue&type=script&lang=js"
export * from "./BloggerLayout.vue?vue&type=script&lang=js"
import style0 from "./BloggerLayout.vue?vue&type=style&index=0&id=353b48cb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353b48cb",
  null
  
)

export default component.exports